import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
  sessiao: function() {
    return Vue.http.get('/api/pagamento/autorizacao').then(res => res.data);
  },
  pagar: function(data) {
    return Vue.http.post('/api/pagamento/pagar', data);
  },
  pagarCheckout: function (data) {
    return Vue.http.post('/api/pagamento/pagarCheckout', data);
  },
  pagarBoletoGetNet: function (data) {
    return Vue.http.post('/api/pagamento/pagarGetNetBoleto', data);
  },
  pagarCreditoGetNet: function (data) {
    return Vue.http.post('/api/pagamento/pagarGetNetCredito', data);
  },
  pagarPayPal: function (data) {
    return Vue.http.post('/api/pagamento/PagarPayPal', data);
  },
  pagarDebitoGetNet: function (data) {
    return Vue.http.post('/api/pagamento/pagarGetNetDebito', data);
  },
  pagarPix: function (data) {
    return Vue.http.post('/api/pagamento/PagarPixCobSantander', data);
  },
  verificarPagamentoPix: function (data) {
    return Vue.http.post('/api/pagamento/VerificarPixCobSantander', data);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/pagamento/servico.js